import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../utility/Button';
import { Formik, Field, ErrorMessage } from 'formik';
import ErrorDisplay from '../utility/ErrorDisplay';
import LottieLoader from '../utility/LottieLoader';
import CustomInput from '../utility/CustomInput';
import Dropdown from '../utility/Dropdown';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { validateEnglishOnly, validateIC, validateMobileNo } from '../../js/validators';

import { tShirtSizes as sizes } from '../../constants';

import {
  SITE_TITLE,
} from '../../constants';

import {
  fetchBookingCompanions,
  postCompanionForm,
} from '../../actions/booking';

import {
  clearApiError,
} from '../../actions/api';

class BookingCompanions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initData: false,
    };
    this.initData = this.initData.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.props.clearApiError();
    this.initData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async initData() {
    const { fetchBookingCompanions, location } = this.props;
    await fetchBookingCompanions(location.search);
    const { error, companions } = this.props;

    const { participants } = companions;

    if (!error && this._isMounted) {
      for (let i = 0; i < participants.length; i++) {
        const { name, nric, mobile_no, tshirt_size } = participants[i];
        this.initialValues = {
          ...this.initialValues,
          [`name${i}`]: name || '',
          [`ic${i}`]: nric || '',
          [`mobile${i}`]: mobile_no && mobile_no.slice(3) || '',
          [`size${i}`]: tshirt_size || 'M',
        };
      }
      this.setState({
        initData: true,
      });
    }
  }

  async submitForm(values) {
    const { companions, postCompanionForm, location } = this.props;
    const { participants } = companions;
    const mobPrefix = '+60';

    const formData = [...Array(participants.length)].reduce((ret, _, idx) => {
      const mobNo = values[`mobile${idx}`];
      ret.participants.push({
        id: participants[idx].id,
        name: values[`name${idx}`] || null,
        ic_no: values[`ic${idx}`] || null,
        mobile_no: mobNo ? mobPrefix.concat(mobNo) : null,
        tshirt_size: values[`size${idx}`],
      });
      return ret;
    }, { participants: [] });

    await postCompanionForm(
      JSON.stringify(formData),
      decodeURIComponent(Cookies.get('XSRF-TOKEN')),
      location.search,
    );
  }

  render() {
    const { initData } = this.state;
    const { error, companions, companionStatus, loading , t } = this.props;
    if(error) {
      return (
        <ErrorDisplay error={error} />
      );
    }
    if(loading || !initData) {
      return (
        <>
          <LottieLoader />
        </>
      );
    }
    if(Object.keys(companionStatus).length > 0) {
      return (
        <div className="fe-booking-companions">
          <Helmet>
            <title>{t('trip:addCompanionDetails')} | { SITE_TITLE }</title>
          </Helmet>
          <div className="container">
            <div className="row">
              <div className="col">
                <h1 className="fe-heading">{t('trip:addCompanionsSuccess')}</h1>
                <div className="fe-booking-companion-info">
                  <h3 className="fe-companion-heading">{ companions.trip_title }</h3>
                  <div className="fe-companion-desc">{t('form:getawayTravelDate')}: <span>{ companions.tour_date }</span></div>
                  <div className="fe-companion-desc">{t('form:numPax')}: <span>{ companions.participants.length }</span></div>
                  <div className="fe-companion-desc">{t('trip:bookingId')}: <span>{ companions.booking_no }</span></div>
                </div>
                <p>{t('trip:companionsSuccessText')}<br/>{t('trip:lookForward')}</p>
                <p>{t('gen:closeTab')}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }
    const { participants } = companions;
    return (
      <div className="fe-booking-companions">
        <Helmet>
          <title>{t('trip:addCompanionDetails')} | { SITE_TITLE }</title>
        </Helmet>
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1 className="fe-heading">{t('trip:addCompanionDetails')}</h1>
              <div className="fe-booking-companion-info">
                <h3 className="fe-companion-heading">{ companions.trip_title }</h3>
                <div className="fe-companion-desc">{t('form:getawayTravelDate')}: <span>{ companions.tour_date }</span></div>
                <div className="fe-companion-desc">{t('form:numPax')}: <span>{ companions.participants.length }</span></div>
                <div className="fe-companion-desc">{t('trip:bookingId')}: <span>{ companions.booking_no }</span></div>
              </div>
              <Formik
                validateOnChange={true}
                validateOnBlur={true}
                initialValues={this.initialValues}
                onSubmit={(values) => {
                  this.submitForm(values);
                }}
              >
                {({ errors, handleSubmit, handleChange, handleBlur, values }) => (
                  <form
                    noValidate
                    onSubmit={ handleSubmit }
                    className="fe-form"
                  >
                    {[...Array(participants.length)].map((_, idx) => {
                      const nameStr = 'name' + idx;
                      const icStr = 'ic' + idx;
                      const mobileStr = 'mobile' + idx;
                      const sizeStr = 'size' + idx;
                      return (
                        <fieldset key={idx}>
                          <div className="fe-form-inner">
                            <div className={'fe-form-field'}>
                              <label htmlFor={nameStr}>{t('form:fullNameAsIC')}</label>
                              <Field
                                onBlur={handleBlur}
                                type="text"
                                name={nameStr}
                                validate={val => val ? validateEnglishOnly(val) : undefined}
                                component={CustomInput}
                              />
                            </div>
                            {/* <div className="fe-form-field">
                              <label htmlFor={sizeStr}>{t('form:tShirtSize')}</label>
                              <Dropdown
                                name={sizeStr}
                                value={ values[sizeStr] }
                                customOnChange={false}
                                onChange={ handleChange }
                                options={sizes}
                              />
                            </div> */}
                            <div className="fe-form-field">
                              <label htmlFor={icStr}>{t('form:icNo')}</label>
                              <Field
                                onBlur={handleBlur}
                                type="text"
                                name={icStr}
                                validate={val => val ? validateIC(val) : undefined}
                                component={CustomInput}
                                numbersOnly
                              />
                            </div>
                            <div className="fe-form-field">
                              <label htmlFor={mobileStr}>{t('form:mobileNo')}</label>
                              <div className="fe-form-field-mobile">
                                <div className="fe-form-mob-prefix">+60</div>
                                <Field
                                  onBlur={handleBlur}
                                  type="text"
                                  name={mobileStr}
                                  validate={val => val ? validateMobileNo(val) : undefined}
                                  component={CustomInput}
                                  showError={false}
                                  numbersOnly
                                />
                              </div>
                              <span className="fe-form-error"><ErrorMessage name={mobileStr} render={msg => t(`error:${msg}`)}/></span>
                            </div>
                          </div>
                        </fieldset>
                      );
                    })}
                    <div className="fe-form-buttons no-margin">
                      <Button
                        type="submit"
                      >
                        {t('form:submit')}
                      </Button>
                    </div>
                    <span className="fe-form-error">{ Object.entries(errors).length > 0 ? t('error:incompleteForm') : '' }</span>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BookingCompanions.propTypes = {
  error: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  clearApiError: PropTypes.func.isRequired,
  fetchBookingCompanions: PropTypes.func.isRequired,
  postCompanionForm: PropTypes.func.isRequired,
  companions: PropTypes.object.isRequired,
  companionStatus: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ bookingState, apiState }) => ({
  companions: bookingState.companionResponse,
  companionStatus: bookingState.companionStatus,
  error: apiState.error,
  loading: bookingState.loading,
});

const mapDispatchToProps = {
  fetchBookingCompanions,
  postCompanionForm,
  clearApiError,
};

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BookingCompanions)));
